<template>
  <div @click="down()">
    <slot>
      <el-button icon="leniu-icon-export" type="primary"
        >批量导出照片
      </el-button>
    </slot>
  </div>
</template>

<script>
import JSZip from 'jszip'
import FileSaver from 'file-saver'

export default {
	components: {},
	beforeRouteEnter (to, from, next) {
		next()
	},
	props: {
		ArrImg: {
			type: Array,
			required: false
		}
	},
	computed: {},
	data () {
		return {}
	},
	mounted () {},
	methods: {
		handleBatchDownload () {
			console.log('图片批量导出', this.$store.getters.url)
		},
		// 批量下载
		async down () {
			const url = this.$store.getters.url
			const data = []
			this.ArrImg.forEach(val => {
				if (val.photoUrl) {
					data.push({
						custName: val.custName,
						custNum: val.custNum,
						photoUrl: val.photoUrl.includes('http') ? val.photoUrl : (url + val.photoUrl)
					})
				}
			})
			console.log(data)
			try {
				const zip = new JSZip()
				// await data.forEach(async val => {
				//   let lst = val.photoUrl.split(".");
				//   let fileType = lst[lst.length - 1];

				//   await this.getBase64Image(val.photoUrl).then(res => {
				//     zip.file(val.custNum + "_" + val.custName + "." + fileType, res, {
				//       base64: true
				//     });
				//   });
				// });
				const failImg = []
				for (let i = 0; i < data.length; i++) {
					if (data[i].photoUrl) {
						const lst = data[i].photoUrl.split('.')
						const fileType = lst[lst.length - 1]
						await this.getBase64Image(data[i].photoUrl).then(res => {
							if (res == 1) {
								failImg.push('该图片不可用:' + data[i].custNum + '_' + data[i].custName + '.' + fileType)
								// console.log('该图片不可用:'+ data[i].custNum + "_" + data[i].custName + "." + fileType)
							} else {
								zip.file(
									data[i].custNum + '_' + data[i].custName + '.' + fileType,
									res,
									{ base64: true }
								)
							}
						})
					}
				}
				console.log(failImg)
				this.downImg(zip)
			} catch (err) {
				console.log('err', err)
			}
		},
		downImg (zip) {
			zip
				.generateAsync({
					type: 'blob'
				})
				.then(content => {
					const fileName = '批量下载图片.zip'
					FileSaver.saveAs(content, fileName)
				})
		},
		//* ***传入图片链接，返回base64数据
		getBase64Image (url) {
			return new Promise((resolve, reject) => {
				let base64 = ''
				const img = new Image()
				// img.setAttribute("crossOrigin", "Anonymous");
				img.crossOrigin = ''
				img.src = url
				img.onload = () => {
					base64 = this.image2Base64(img, url.split('.')[1])
					resolve(base64.split('base64,')[1]) // base64去掉base64头
				}
				img.onerror = () => resolve(1) // 这里可能会有跨域失败的问题，解决方案同上，url + 随机数
			})
		},
		image2Base64 (img, fileType = 'jpeg') {
			const canvas = document.createElement('canvas')
			canvas.width = img.width
			canvas.height = img.height
			canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
			return canvas.toDataURL('image/' + fileType)
		}

		// async handleBatchDownload(selectImgList) {
		//   let data = [];
		//   this.ArrImg.forEach(val => {
		//     data.push({
		//       custName: val.custName,
		//       custNum: val.custNum,
		//       photoUrl: val.photoUrl
		//     });
		//   });
		//   console.log(data);
		//   // const zip = new JSZip()
		//   // const cache = {}
		//   // const promises = []
		//   // await data.forEach(item => {
		//   //     const promise = this.getFile(item).then(data => { // 下载文件, 并存成ArrayBuffer对象
		//   //     const arr_name = item.split("/");
		//   //     let file_name = arr_name[arr_name.length - 1] // 获取文件名
		//   //     // if (file_name.indexOf('.png') == -1) {
		//   //     //    file_name = file_name + '.png'
		//   //     // }
		//   //     zip.file(file_name, data, {
		//   //         binary: true
		//   //     }) // 逐个添加文件
		//   //     cache[file_name] = data
		//   //     })
		//   //     promises.push(promise)
		//   // })
		//   // Promise.all(promises).then(() => {
		//   //     zip.generateAsync({
		//   //     type: "blob"
		//   //     }).then(content => { // 生成二进制流
		//   //     FileSaver.saveAs(content, "photo.zip") // 利用file-saver保存文件
		//   //     })
		//   // })
		// }
	}
}
</script>
